export default __webpack_public_path__ + "static/media/033-mark.10205135.svg";